import { Box, Typography } from '@mui/material'
import CoreModal from 'core/CoreModal'
import FailIcon from 'assets/icons-color/fail.png'
import { betaLaunchStore } from 'stores'
import { observer } from 'mobx-react-lite'

interface Props {
  onClose: () => void
}

const CapIsFully = observer(({ onClose }: Props) => {
  const { maxTVL } = betaLaunchStore

  const Content = (
    <Box
      sx={{
        textAlign: 'center',
      }}
    >
      <img src={FailIcon} alt="FailIcon" width={180} height={180} />
      <Box sx={{ margin: '0px 0px 16px 0px' }}>
        <Typography variant="h5">We’re sorry. The cap on the pool’s</Typography>
        <Typography variant="h5">TVL had been reached.</Typography>
      </Box>

      <Typography variant="body1" align="center" paragraph mb="0px">
        Edge imposed the cap of ${maxTVL.toNumber().toLocaleString('en-US')} to
        contain potential damage and secure your finances.
      </Typography>

      <Typography variant="body1" align="center" paragraph>
        Now that it has been reached, we are thoroughly considering the option
        of rising the cap. The decision will be made known soon!
      </Typography>
    </Box>
  )

  return <CoreModal open content={Content} onClose={onClose} />
})

export default CapIsFully
